
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    const reviewWidget = document.querySelector('[id^="shopify-block-"][id*="judge_me_reviews_review_widget"]');

    const targetContainers = Array.from(document.querySelectorAll('collapsible-tab[data-block-id]'))
      .filter(tab => tab.getAttribute('data-block-id').trim() === 'collapsible-tab-collapsible_tab_4gw87D')
      .map(tab => tab.querySelector('.m-collapsible--content'));

    if (reviewWidget && targetContainers.length > 0) {
      targetContainers.forEach((container, index) => {
        if (container) {
          if (index === 0) {
            container.appendChild(reviewWidget);
          } else {
            const clonedWidget = reviewWidget.cloneNode(true);
            container.appendChild(clonedWidget);
          }
        }
      });
    }
  }, 2000); // Esperar 2 segundos luego de que el DOM esté listo
});